import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	KodKorekce: null as string | null,
	Oc: null as number | null,
	Poznamka: null as string | null,
	ProvozovnaId: null as number | null,
	Text: null as string | null,
	UniqCheckPrp: null as boolean | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	ZakazkakorekcePzn: null as number | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		ZakazkakorekcePzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
